import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'LOGIN_PASSWORD_RECOVERY_CONFIRM_TITLE',
    defaultMessage: 'Bestätigungscode eingeben',
  },
  description: {
    id: 'LOGIN_PASSWORD_RECOVERY_CONFIRM_DESCRIPTION',
    defaultMessage:
      'Bitte geben Sie den Code ein, den wir Ihnen gerade an {username} gesendet haben.',
  },
  backLinkText: {
    id: 'LOGIN_PASSWORD_RECOVERY_CONFIRM_BACK',
    defaultMessage: 'E-Mail Adresse / Handynr. korrigieren',
  },
  submitLabel: {
    id: 'LOGIN_PASSWORD_RECOVERY_CONFIRM_SUBMIT',
    defaultMessage: 'Weiter',
  },
});
